import { revokeUserToken, useAuthStore } from "@entities/user-tokens";

/**
 * アドインのログアウト処理。
 *
 * 1. サーバー (`/user-tokens` DELETE) で auth_refresh Cookie のセッションを revoke
 *    (Set-Cookie: Max-Age=0 でブラウザから Cookie が消える)
 * 2. クライアント側 auth store を unauthenticated に更新 (UI 即時反映)
 *
 * サーバー revoke が失敗してもクライアント状態は遷移させる (option 2a)。
 */
export async function logout(): Promise<void> {
    try {
        await revokeUserToken();
    } catch {
        // ネットワーク失敗等は無視。クライアント状態は確実に遷移させる。
    }
    useAuthStore.getState().setUnauthenticated();
}
